'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainNavigation = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    token: state.auth.token
  };
}, { logout: _auth.logout }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MainNavigation, _Component);

  function MainNavigation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MainNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MainNavigation.__proto__ || (0, _getPrototypeOf2.default)(MainNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MainNavigation, [{
    key: 'render',
    value: function render() {
      var styles = require('./MainNavigation.scss');
      var sections = [{
        label: 'Contenu',
        links: [{
          label: 'Niveaux',
          pathname: '/schoollevels'
        }, {
          label: 'Synchronisation',
          pathname: '/synchronization'
        }]
      }];

      return _react2.default.createElement(
        'aside',
        { id: 'main-nav', className: styles.menu },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: styles.header }),
          _react2.default.createElement(
            'nav',
            null,
            sections.map(function (section, sectionIndex) {
              return _react2.default.createElement(
                'div',
                { key: sectionIndex },
                _react2.default.createElement(
                  'h4',
                  { className: styles.title },
                  section.label
                ),
                _react2.default.createElement(
                  'ul',
                  { className: styles.nav },
                  section.links.map(function (link, linkIndex) {
                    return _react2.default.createElement(
                      'li',
                      { key: linkIndex },
                      _react2.default.createElement(
                        _reactRouter.Link,
                        { activeClassName: styles.activeItem, className: styles.item,
                          to: link.pathname },
                        link.label
                      )
                    );
                  })
                )
              );
            }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'ul',
                { className: styles.nav },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: '#', className: styles.item, onClick: this.handleLogout },
                    'Se d\xE9connecter'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return MainNavigation;
}(_react.Component), _class2.propTypes = {
  logout: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = MainNavigation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MainNavigation/MainNavigation.js
// module id = 1179
// module chunks = 0